import { Injectable } from '@angular/core';
import { Device } from '@ionic-native/device/ngx';
import { OneSignal } from '@ionic-native/onesignal/ngx';
import { AlertController } from '@ionic/angular';

import { AauthService } from 'src/app/services/aauth.service';
import { ModelService } from 'src/app/services/model.service';

import { LanguageService } from 'src/app/services/language.service';

 

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

    deviceId: any = null;
    alertActive:   any = null;
    responseData: any;
    isLogged:     any = false;


    appId: string = '';
    androidId: string = '';


    // const onesignalAppId   = '80ed673f-5ec4-430c-ab66-f0adaf2addb5',
    //   onesinalAndroidId = '23276053359';
  
    constructor(
        private device: Device,
        private oneSignal: OneSignal,
        private modelService: ModelService,
        private alertController: AlertController,
        private languageService: LanguageService,
        private aauthService: AauthService
        ) { }

    /**
     * Inicializar o storage (chamando no init do appComponent)
     * 
     * @reeturns Promise
     * @author Demerson Carvalho 
     */
    async initialize(appId: any, androidId: any): Promise<void> { 
        
        // Checar se está logado - false para não retornar para a página de login, pois já estamos nela
        // this.isLogged = await this.aauthService.loggedCheck(false);

        // Fazer o setup do onesignal
        this.oneSignal.startInit(appId, androidId);

        this.oneSignal.inFocusDisplaying(this.oneSignal.OSInFocusDisplayOption.InAppAlert);

        this.received();
        this.opened();


        // Pega o ID do dispositivo e salvar na sessão
        await this.deviceSet();

        this.oneSignal.endInit();

     
    }

    /**
     * Salvar os dados do dispotivo no storage (será enviado na função de login para ser salvo no server)
     * 
     * @returns Promise
     * @author Demerson Carvalho
     */
    async deviceSet(): Promise<void> {
    
        this.oneSignal.getIds().then( async (response) => {
            // armazenar o id do dispositivo na sessão
            
            console.log('resposta do onesignal ' + (response.userId));

            await this.modelService.setRoot('device', (response.userId != null ? response.userId : ''));
            this.deviceId = response.userId;

        });

    }  

    async deviceGet(isCordova: boolean = false) {
        this.deviceId = (this.deviceId == null) ?
            await this.modelService.getRoot('device') : this.deviceId;
 
        if(isCordova == true) { 
         
            if(this.deviceId == null) {
                this.deviceId = await this.deviceSet();               
            }
            
        } else {
          // fazer para navegadores web
          let loggedUser = await this.modelService.getRoot('loggedUser');
          this.deviceId  = (loggedUser != null ? loggedUser : '') + '-atu-navegador-web'
        }
    
        return this.deviceId;
      } 
    

    /**
     * Evento para notificação recebida
     * 
     * @returns Promise
     * @author Demerson Carvalho
     */
    async received(): Promise<any> {
                
        this.oneSignal.handleNotificationReceived().subscribe( (response) => {
         
            this.responseData  = response.payload;  

            this.alertInApp(this.responseData.additionalData.logged, this.responseData.title, this.responseData.body, this.responseData.additionalData);
           
        });
    }
  
    /**
     * Evento para quando a notificação é aberta /clicada
     * 
     * @returns Promise
     * @author Demerson Carvalho
     */
     async opened(): Promise<any> {
                
        // Notification was really clicked/opened
        this.oneSignal.handleNotificationOpened().subscribe((response) => {
            // Just a note that the data is a different place here!
            let task = response.notification.payload.additionalData.task;
            
            console.log(this.responseData);

            // this.alertInApp('Notification opened', 'Voce ja viu isto antes', task);
      });
    }


  /**
   * Exibir alerta no aplicativo
   * 
   * @param  {string} title
   * @param  {any} content
   * @param  {any} action
   * @returns Promise
   * @author Demerson Carvalho
   */
  async alertInApp(loggedRequired: boolean = false, title: string, content: any, action: any): Promise<any> {

    // ver essa parte de notificacao dentro do app depois
    if(1 == 1) return false;

    if(loggedRequired === true) {
        if(this.isLogged === false) {
            console.log('Login necessário para exibir o alerta. Está logado? ' + this.isLogged);
            return false;
        }
            
    }
  
    let buttonTitle = await this.languageService.get('OK');

    this.alertActive = await this.alertController.create({
        header: title,
        subHeader: content,
        buttons: [
          {
            text: `${buttonTitle}`,
            handler: () => {} // E.g: Navigate to a specific screen
          }
        ]
      })

      this.alertActive.present();
  }

  
}


